import validatorMap from "@/const/map/validatorMap";

/**
 * @todo Get useIsMobile.
 * @returns {Boolean} useIsMobile
 */
export const useIsMobile = () => {
  return validatorMap.mobile.test(navigator.userAgent);
};


export const isPhonePortrait = () => {
  return window.innerWidth <= 767 || false;
};

export const isPcMax = () => {
  return window.innerWidth > 1440 || false;
};

/**
 * @todo 字符串分隔符替换成驼峰.
 * @returns {string} str
 */
export const useHump = (str) => {
  const re = /-(\w)/g;
  str = str.replace(re, function ($0, $1) {
    return $1.toUpperCase();
  });
  return str;
};

/**
 * @todo 字符串首字母大写
 * @returns {string} str
 */
export const useFirstUpperCase = (str) => {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

// 获取blob流
export const useGetBlob = (url) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function () {
      if (xhr.status === 200) {
        resolve(xhr.response);
      } else {
        reject("error");
      }
    };
    xhr.send();
  });
};
/**
 * @todo 预览PDF
 * @returns {void}
 */
export const usePreviewPdf = async ({ file, fileLink }) => {
  if (file) { fileLink = URL.createObjectURL(file); }
  const blobStream = await useGetBlob(fileLink);
  const blob = new Blob([blobStream], {
    type: "application/pdf;charset=utf-8",
  });
  const fileURL = URL.createObjectURL(blob);
  window.open(fileURL, "_blank");
};
/**
 * @todo 预览Image
 * @returns {void}
 */
export const usePreviewImage = ({ file, fileLink }) => {
  if (file) { fileLink = URL.createObjectURL(file); }
  const image = new Image();
  image.src = fileLink;
  const imgWindow = window.open(fileLink, "_blank");
  imgWindow.document.write(image.outerHTML);
  imgWindow.document.title = file?.name;
};

/**
 * @todo 预览/下载文件
 * @returns {void}
 */
export const usePreviewFiles = ({ file }) => {
  if (file) {
    window.open(window.URL.createObjectURL(file));
  }
}

// 获取品牌，如kd，pelonisv2，midea等
export const useBrand = () => {
  return process.env.BRAND;
}

/* eslint-disable */
export const useFlattenSubmitData = (data, type = 1) => {
  let result = {}
  for (const key in data) {
    if (data.hasOwnProperty(key)) {
      const value = data[key];
      // 区分data 和 label
      const arrayValue = type === 1 ? value : value.value
      if (Array.isArray(arrayValue) && key !== 'product' && key !== 'optIn') {
        const obj = arrayValue.reduce((acc, arr) => {
          for (const aKey in arr) {
            acc[aKey] = arr[aKey]
          }
          return acc;
        }, {});
        result = {
          ...result,
          ...obj,
        }
      } else {
        // 否则，将键值对添加到结果对象中  
        result[key] = value;
      }
    }
  }
  return result;
}
/* eslint-disable */

// 单词首字母大写
export const useUcFirst = (str) => {
  const characters = [...str].map((item, idx) => {
    if (idx === 0) {
      item = item.toUpperCase();
    } else {
      item = item.toLowerCase();
    }
    return item;
  });
  str = characters.join("");
  return str;
};

const getBlob = (url) => {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function () {
      if (xhr.status === 200) {
        resolve(xhr.response);
      } else {
        reject("error");
      }
    }
    xhr.send();
  });
};

// 获取文件类型
export const getFileAttrs = (fileLink = "") => {
  let fileType = "";
  let fileName = "";
  if (!fileLink) {
    return "";
  }
  if (/.(jpeg|jpg|png|gif)$/i.test(fileLink)) {
    fileType = "Image";
  } else {
    fileType = "Pdf";
  }
  fileName = fileLink.split("/");
  if (fileName && fileName.length && fileName.length > 1) {
    fileName = fileName[fileName.length - 1];
  }
  return { fileType, fileName };
};

export async function previewPdf({ fileLink }) {
  const blobStream = await getBlob(fileLink);
  const blob = new Blob([blobStream], {
    type: "application/pdf;charset=utf-8"
  });
  const fileURL = URL.createObjectURL(blob);
  window.open(fileURL, "_blank");
}


export const previewImage = ({ fileLink, fileName }) => {
  const image = new Image();
  image.src = fileLink;
  const imgWindow = window.open(fileLink, "_blank");
  imgWindow.document.write(image.outerHTML);
  imgWindow.document.title = fileName;
};

export const downloadFile = (fileLink, fileName) => {
  const a = document.createElement("a");
  a.href = fileLink;
  a.download = fileName;
  a.click();
};

// 针对energy label a标签是否需要download属性
/**
 * 
 * @param {fileLink} 文件链接
 * @return {Boolen}  下载的文件名表示 需要，false 不需要
 */
export const isNeedDownloadAtrr = (fileLink) => {
  if (fileLink) {
    const { fileType,fileName } = getFileAttrs(fileLink);
    return !(fileType === "Pdf" && !isPhonePortrait())?fileName:false;
  }
  return false;
};


/**
 * @todo 判断当前是否为阿拉伯站点（RTL布局）
 * @returns {Boolean} 是否为阿拉伯站点
 */
export const useIsArabicSite = () => {
  return document.documentElement.getAttribute('dir') === 'rtl';
};

